import { ApiTemplate,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'
import { fromJS } from 'immutable';

export default (file,flowId) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    const Authorization = UserToken;
    const url = ApiTemplate + 'flow/assets';
    // const url = 'http://localhost:9988/apitemplate/flow/assets';

    const data = new FormData();
    data.append('file', file );
    data.append('flow_id',flowId);

    const argument = {
        method: 'POST',
        headers : {
            'Authorization': Authorization
        },
        body : data
    };
    const response = await doFetch(url,argument);
    
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });

    try{
        if(response.ok){
            var res = fromJS(await response.json());
            // console.log(res, 'res upload');
            
            // res = res.get('upload-files');
            // res = res.get(0)
            return fromJS({
                'success': true
            });
        }
    }catch(ex){

    }
    
    return fromJS({
        'success': false
    })
};